export * from './sing-re.module';
export * from './sing-re.component';
export * from './sing-recorder/sing-recorder.component';
export * from './sing-uploader/sing-uploader.component';
export * from './sing-upload-success/sing-upload-success.component';
export * from './remix-recording/remix-recording.component';
